import * as Api from "@api";
import * as C from "@components";
import React from "react";
import { ProductXLMouthpieces } from "./ProductXLMouthpieces";
import css from "./product-xl-mouthpieces.module.scss";
import type { ProductXLMouthpiecesSectionProps } from "./types";
import * as P from "@/parts";

export const ProductXLMouthpiecesSection = ({ pageContent, ...props }: ProductXLMouthpiecesSectionProps): React.FunctionComponentElement<ProductXLMouthpiecesSectionProps> =>
{
    const footer = pageContent["mouthpieces.footer"];
    // Placed twice: under the thumbnail grid on desktop, where it lines up with the first
    // column, and under the whole block on mobile, where the grid is a slider instead.
    const footnote = footer !== undefined
        ? <C.PageContent {...footer} typography={C.Typography.P5Caption} textColor={C.Color.BlackDomina} />
        : undefined;

    return (
        <C.PageSection>
            <C.Card className={css["card"]}>
                <C.PageContent {...pageContent["mouthpieces.headline"]} className={css["card__headline"]} centered typography={C.Typography.H2} maxWidth={C.Width.W756} margins={{ bottom: C.Margin.D24 }} textColor={C.Color.BlackDomina} />
                <C.PageContent {...pageContent["mouthpieces.body"]} centered typography={C.Typography.P1} maxWidth={C.Width.W618} textColor={C.Color.BlackDomina} />
                <ProductXLMouthpieces {...props} pageContent={pageContent} footer={footnote} />
                {footnote !== undefined && <div className={css["footnote-mobile"]}>{footnote}</div>}
            </C.Card>
            {!Api.SnaptixHidden && <P.AnnouncementSnaptixMouthpiece isPageXL className='mt-6' />}
        </C.PageSection>
    );
};